<template>
  <div class="padding text-center" v-if="!isLoadingEmded || slideEmbded.attributes">
    <div v-if="isEmbedSrcAvailable" class="embed-slide">
      <div v-if="isIframeCode">
        <div class="embed-slide-iframe" v-html="sanitizedEmbedLink" />
      </div>
      <iframe
        v-else
        class="embed-iframe"
        width="668"
        height="375.75"
        :src="slideEmbded.attributes.embedSrc"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <div class="no-data" v-else>
      <p class="custom-mb-3">
        {{ $t("seeSlideOnPresenterScreen") }}
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SlideApi from '@/api/slide'
import { EMBED_URL_STRATEGIES } from '@/utils/url.utils'

export default {
  data() {
    return {
      slideEmbded: {},
      isLoadingEmded: true,
    }
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
    isEmbedSrcAvailable() {
      return this.slideEmbded.attributes && this.slideEmbded.attributes.embedSrc && this.slideEmbded.attributes.showIframeOnParticipantScreen
    },
    sanitizedEmbedLink() {
      const embedIframeCode = this.slideEmbded?.attributes?.embedSrc
      if (!embedIframeCode) return null
      const template = document.createElement('template')
      template.innerHTML = embedIframeCode.trim() // Trim to avoid accidental whitespace
      const element = template.content.firstChild
      element.style.width = '100%'
      element.style.height = '100%'
      element.style.border = 'none'
      element.style.background = 'transparent'
      return element.outerHTML
    },
    isIframeCode() {
      return this.slideEmbded.attributes.embedSrc.includes('<iframe')
    },
  },
  created() {
    this.getSlideEmbed()
  },
  methods: {
    embedSrc(originalEmbedSrc) {
      if (!originalEmbedSrc) return null

      // Find the first matching strategy and apply it
      const matchingStrategy = Object.entries(EMBED_URL_STRATEGIES).find(([key]) => originalEmbedSrc.includes(key))

      return matchingStrategy
        ? matchingStrategy[1](originalEmbedSrc)
        : originalEmbedSrc
    },
    async getSlideEmbed() {
      const resp = await SlideApi.getSlideEmbed(this.slide.id)
      if (resp && resp.attributes && resp.attributes.embedSrc) {
        resp.attributes.embedSrc = this.embedSrc(resp.attributes.embedSrc)
        this.slideEmbded = resp
      }
      this.isLoadingEmded = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.embed-slide {
  position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    padding-top: 25px;
    height: 0;
  .embed-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #00000026;
    border-radius: 4px;
  }
}

.embed-slide-iframe {
  max-width: 600px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  iframe {
    width: 100% !important;
    height: 100%;
    border: none;
    background-color: transparent;

  }
}

</style>
